import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import paneheader from "../../../../assets/images/docs/panes/paneheader.png";
import paneheaderhovered from "../../../../assets/images/docs/panes/paneheaderhovered.png";
import panefooter from "../../../../assets/images/docs/panebottom.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  paneheader,
  paneheaderhovered,
  panefooter,
  React
};